<template>
    <div class="page-company">
        <el-dialog
                :title="(editMode ? 'Редактировать' : 'Добавить') + ' организацию'"
                :visible.sync="addVisible"
                width="456px"
        >
            <div>
                <el-form class="m-t-10" ref="validationForm" :model="model" v-loading="loading">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Название" prop="Name" :rules="[{ required: true, message: 'Название не заполнено' }]">
                                <el-input v-model="model.Name" placeholder="Введите название"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Номер телефона" prop="Phone" :rules="[{ required: true, message: 'Номер телефона не заполнен' }]">
                                <el-input v-model="model.Phone" placeholder="Введите номер"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="m-b-20">
                        <el-col :span="24">
                            <el-checkbox v-model="model.AllowGuestsOverCustomers">Разрешить гостям пользоваться местами для клиентов</el-checkbox><br>
                            <el-checkbox class="m-l-0" v-model="model.AllowCustomersOverGuests">Разрешить клиентам пользоваться местами для гостей</el-checkbox>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Тариф">
                                <el-select :clearable="true" v-model="model.TariffID" placeholder="Выберите тариф" class="w-100">
                                    <el-option
                                            v-for="item in tarifDict"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Группа">
                                <el-select :clearable="true" v-model="model.CustomerGroupId" placeholder="Укажите группу клиента" class="w-100">
                                    <el-option
                                            v-for="item in customerGroupDict"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="p-b-10  m-t-30">
                    <el-row :gutter="20">
                        <el-col :span="12" align="left" class="d-flex align-items-left">
                            <el-button class="m-l-20" type="link" @click="close">Закрыть</el-button>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" @click="add" :loading="loading">{{(editMode ? 'Сохранить' : 'Добавить')}}</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>

        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="18" :xl="18" class="m-b-10 m-b-md-0">
                    <el-input class="w-100"
                              placeholder="Искать организацию"
                              v-model="form.SearchString"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="12" :lg="6" :xl="6" align="right" class="d-flex">
                    <el-button class="w-50" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                    <el-button class="w-50" @click="addForm" icon="icon-plus">Добавить</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="Name" label="Название">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                <a href="#" @click.prevent="showDetails(scope.row.ID)" class="color-black">
                                    {{ scope.row.Name }}
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Phone" label="Телефон" v-if="$mobile()" />
                    <el-table-column prop="TariffID" label="Тариф" v-if="$mobile()">
                        <template slot-scope="scope" v-if="tarifDict && tarifDict.find(x => x.ID == scope.row.TariffID)">
                            {{ tarifDict.find(x => x.ID == scope.row.TariffID).Name }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="MaxAllowedCustomers" label="Max Клиентов" v-if="$mobile()" />
                    <el-table-column prop="MaxAllowedGuests" label="Max Гостей" v-if="$mobile()" />
                    <el-table-column prop="Description" label="Описание" v-if="$mobile()" />
                    <el-table-column prop="WalletOnline" label="Кошелек" v-if="$mobile()">
                        <template slot-scope="scope">
                            <wallet :wallet="scope.row.WalletOnline" :ownerType="1" :id="scope.row.ID" @update="getData"></wallet>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="Подробнее"
                            width="120px"
                            align="right"
                    >
                        <template slot-scope="scope">
                            <el-button @click="editForm(scope.row)" icon="icon-edit-2" class="el-button--icon" size="mini" title="Редактировать"></el-button>
                            <el-button @click="deleteItem(scope.row.ID)" icon="icon-trash" class="el-button--icon" size="mini" title="Удалить"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-t-20 text-center">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="form.Page"
                            :page-sizes="[10, 20, 100, 200, 300, 400]"
                            :page-size="form.PageSize"
                            layout="sizes, prev, pager, next, total"
                            :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Vue from 'vue'
import Wallet from '@/components/Wallet'

export default {
    components: { Wallet },
    data () {
        return {
            loading: false,
            form: {
                From: Vue.moment().add(-30, 'days').format('DD/MM/YYYY HH:mm'),
                To: Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm'),
                SearchString: '',
                Page: 1,
                PageSize: 20
            },
            model: {
                Name: '',
                Phone: ''
            },
            total: 0,
            dataTable: [],
            tarifDict: '',
            customerGroupDict: '',
            addVisible: false,
            editMode: false
        }
    },
    created () {
        this.getTarif()
        this.getCustomerGroup()
        this.getData()
    },
    methods: {
        changeDate (date) {
            this.form.From = date[0]
            this.form.To = date[1]
            this.getData()
        },
        handleSizeChange (val) {
            this.form.PageSize = val
            this.getData()
        },
        handleCurrentChange (val) {
            this.form.Page = val
            this.getData()
        },
        handleFilter () {
            this.getData()
        },
        getData () {
            this.loading = true

            let request = Object.assign({
                Name: "GetItemsList",
                ItemType: "Company",
                OperatorName: "Admin"
            }, this.form)

            this.$api.Main.getCompanies(request).then(response => {
                this.loading = false
                this.dataTable = response.Items
                this.total = response.Total
            }).catch (() => {
                this.loading = false
            })
        },
        getCustomerGroup () {
            this.$api.Main.getCustomerGroup().then(response => {
                this.customerGroupDict = response.Items
            })
        },
        getTarif () {
            this.$api.Main.getTarif().then(response => {
                this.tarifDict = response.Items
            })
        },
        showDetails (id) {
            this.$router.push({ name: 'companyDetails', params: { id: id } })
        },
        add () {
            this.$refs['validationForm'].validate((valid) => {
                if (valid) {
                    this.clearFormErrors('validationForm')
                    this.loading = true

                    let request = Vue.$props('AddItem', 'Company', this.model)

                    this.$api.Main.addCompany(request).then(response => {
                        this.loading = false

                        if (response.Result === "Success") {
                            this.resetForm()
                            this.$message({
                                message: 'Организация добавлена',
                                type: 'success',
                                res: response
                            })

                            this.addVisible = false
                            this.getData()

                            setTimeout(() => this.clearFormErrors('validationForm'), 500)
                        }
                        else {
                            this.$message({
                                message: response.ErrorString,
                                type: 'error',
                                res: response
                            })
                        }
                    }).catch((error) => {
                        this.loading = false
                        this.showFormErrors(error, 'validationForm')
                    })
                }
            })
        },
        addForm () {
            this.resetForm()
            setTimeout(() => this.clearFormErrors('validationForm'), 1)
            this.editMode = false
            this.addVisible = true
        },
        editForm (row) {
            setTimeout(() => this.clearFormErrors('validationForm'), 1)
            this.editMode = true
            this.model = {...row}
            this.addVisible = true
        },
        close() {
            this.addVisible = false
            this.resetForm()
            setTimeout(() => this.clearFormErrors('validationForm'), 500)
        },
        resetForm () {
            this.model = {
                Name: '',
                Phone: '',
                AllowGuestsOverCustomers: null,
                AllowCustomersOverGuests: null,
                TariffID: '',
                CustomerGroupId: ''
            }
        },
        deleteItem (id) {
            this.$confirm('Вы уверены что хотите удалить организацию?').then(() => {
                let request = {
                    Name: "RemoveItem",
                    ItemType: "Company",
                    ItemId: id
                }

                this.$api.Main.deleteCompany(request).then(response => {
                    if (response.Result === 'Failed') {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error'
                        })
                    }
                    else {
                        this.$message({
                            message: 'Организация удалена',
                            type: 'success',
                            res: response
                        })
                        this.getData()
                    }
                })
            })
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
